module.exports = __webpack_public_path__ + "img/blueTheme.c12c9f7f.png";